<template>
  <div id="app">
    <router-view />
    <Footer />
  </div>
</template>

<script>
  import Footer from '@/components/FooterComponent.vue';

  export default {
    name: 'App',
    components: {
      Footer
    },
  }
</script>

<style>
  @font-face {
    font-family: "Proxima Nova Bold";
    src: url('/fonts/Proxima-Nova-Bold.otf');
  }

  @font-face {
    font-family: "ProximaNova";
    src: url('/fonts/ProximaNova-Regular.otf');
  }

  :root {
    --blue: #86dade !important;
    --blue2: #33c2c9 !important;
    --blue3: #1d95fc !important;
    --blue4: #5eaff5 !important;
    --blue5: #0d65b7 !important;
    --blue6: #2380d8 !important;
    --blue7: #0665b7 !important;
    --black: #000000 !important;
    --green: #49f872 !important;
    --white: #ffffff !important;
    --grey: #eeeeee !important;
    --grey2: #cccccc !important;
    --grey3: #f6f6f6 !important;
    --font-family-proxima-nova: ProximaNova !important;
    position: relative !important;
    min-height: 100% !important;
  }

  body {
    font-family: var(--font-family-proxima-nova) !important;
    background-color: #ffffff !important;
    margin-bottom: 60px !important;
  }

  .row {
    margin-right: 0px !important;
  }

  .content {
    min-height: 400px !important;
  }

  .Grupo-30 {
    width: 113px !important;
    height: 34px !important;
    object-fit: contain !important;
  }

  /* authentication styles*/
  .logo-header-authentication {
    width: 230px !important;
    height: 68px !important;
    object-fit: contain !important;
    background: url('/img/group-10.png') !important;
    background-position: top center !important;
    background-repeat: no-repeat !important;
    /* background-size: cover; */
  }

  .logo {
    width: 230px !important;
    height: 68px !important;
    object-fit: contain !important;
    background: url('/img/group-10.png') !important;
    background-position: top center !important;
    background-repeat: no-repeat !important;
    /* background-size: cover; */
  }

  .title {
    height: 20px !important;
    font-family: ProximaNova !important;
    font-size: 20px !important;
    font-weight: bold !important;
    font-stretch: normal !important;
    font-style: normal !important;
    line-height: 1.2 !important;
    letter-spacing: normal !important;
    text-align: center !important;
    color: var(--black) !important;
  }

  .title-details {
    height: 18px !important;
    font-family: ProximaNova !important;
    font-size: 18px !important;
    font-weight: normal !important;
    font-stretch: normal !important;
    font-style: normal !important;
    line-height: 1.22 !important;
    letter-spacing: normal !important;
    text-align: center !important;
    color: var(--black) !important;
  }

  .button-font {
    height: 20px !important;
    font-family: ProximaNova !important;
    font-size: 20px !important;
    font-weight: bold !important;
    font-stretch: normal !important;
    font-style: normal !important;
    line-height: 1.2 !important;
    letter-spacing: normal !important;
    text-align: center !important;
    color: #ffffff !important;
  }

  .btn-custom {
    width: 189px !important;
    height: 50px !important;
    background-color: #33c2c9 !important;
    border-radius: initial !important
  }

  .form-control-custom {
    border-radius: 0rem !important;
    height: 50px !important;
    font-family: ProximaNova !important;
    font-size: 18px !important;
    font-weight: normal !important;
    font-stretch: normal !important;
    font-style: normal !important;
    line-height: 1.22 !important;
    letter-spacing: normal !important;
    text-align: left !important;
    color: #777777 !important;
  }

  .form-link {
    height: 15px !important;
    font-family: ProximaNova !important;
    font-size: 15px !important;
    font-weight: normal !important;
    font-stretch: normal !important;
    font-style: italic !important;
    line-height: 1.2 !important;
    letter-spacing: normal !important;
    color: #777777 !important;
  }
</style>